module.exports = __webpack_public_path__ + "img/ford-transit-van.png.295c6c42.webp";